import * as React from 'react'
import { Provider } from 'react-redux'
import store from '../../../store'
import WarehouseRentListOverview from './warehouse_rent_list_overview'
import { Element } from '../warehouse_rent_list_app/warehouse_rent_list/warehouse_rent_list_types'

interface WarehouseRentListOverviewAppProps {
  initialData: {
    rentedItems: Record<string, any>
    elementGroups: Record<string, string>
    groupedAvailableElements: Record<string, Element[]>
  }
  startDate: string
  endDate: string
}

export default function WarehouseRentListOverviewApp(props: WarehouseRentListOverviewAppProps): React.ReactElement {
  return (
    <Provider store={store}>
      <WarehouseRentListOverview {...props} />
    </Provider>
  )
}
